import {
  BUILD_EMPLOYMENT,
  EMPLOYMENT_CHANGED,
  UPDATE_EMPLOYMENTS_START,
  UPDATE_EMPLOYMENTS_SUCCESS,
  UPDATE_EMPLOYMENTS_FAILURE,
} from './types';

export const buildEmployment = (payload) => ({
  type: BUILD_EMPLOYMENT,
  payload: payload
})

export const employmentChanged = (payload) => ({
  type: EMPLOYMENT_CHANGED,
  payload: payload,
})

export const updateEmploymentsStart = (payload) => ({
  type: UPDATE_EMPLOYMENTS_START,
  payload: payload,
})

export const updateEmploymentsSuccess = (payload) => ({
  type: UPDATE_EMPLOYMENTS_SUCCESS,
  payload: payload,
})

export const updateEmploymentsFailure = (payload) => ({
  type: UPDATE_EMPLOYMENTS_FAILURE,
  payload: payload,
})
